export interface RetentionPolicyInfo {
  expirationMonths: number;
  thresholdDays: number;
}

export const RetentionPolicyConstants =  ['FILE', 'CHAT', 'CHAT_DELETED_AGENT', 'PRIVATE_SHARED_AGENT', 'PUBLIC_AGENT'] as const

export type RetentionPolicy = typeof RetentionPolicyConstants[number]

export const RetentionPolicyDetails: Record<RetentionPolicy, RetentionPolicyInfo> = {
  FILE: { expirationMonths: 12, thresholdDays: 30 },
  CHAT: { expirationMonths: 12, thresholdDays: 30 },
  CHAT_DELETED_AGENT: { expirationMonths: 1, thresholdDays: 30 },
  PRIVATE_SHARED_AGENT: { expirationMonths: 12, thresholdDays: 30 },
  PUBLIC_AGENT: { expirationMonths: 6, thresholdDays: 30 }
};

export interface RetentionPolicyChip {
  date: Date;
  type: RetentionPolicy;
  nonExpiringText?: string;
}
